import React from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import electronBridge from '../utils/electronBridge';
import { getWatchUrl, getEmbedUrl } from '../services/youtubeService';

export default function YouTubeVideoPlayer({ videoId, title, onClose }) {
    if (electronBridge.isElectron) {
        electronBridge.ipcRenderer.send('open-urlInExternal', getWatchUrl(videoId));
        onClose?.();
        return null;
    }

    return (
        <Modal
            open={true}
            onClose={onClose}
            center
            container={document.querySelector('.main-content') || undefined}
            classNames={{
                modal: 'youtube-player-modal',
                overlay: 'youtube-player-overlay',
            }}
            styles={{
                modal: {
                    background: '#0a0a1a',
                    padding: '0',
                    maxWidth: '900px',
                    width: '90vw',
                    borderRadius: '12px',
                    overflow: 'hidden',
                },
            }}
        >
            <div className="flex flex-col">
                <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
                    <iframe
                        className="absolute top-0 left-0 w-full h-full"
                        src={getEmbedUrl(videoId)}
                        title={title || 'YouTube Video'}
                        allow="autoplay; encrypted-media; picture-in-picture"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        frameBorder="0"
                    />
                </div>
                {title && (
                    <div className="p-4 bg-[#0a0a1a]">
                        <h3 className="text-white font-semibold text-lg">{title}</h3>
                        <button
                            onClick={() => window.open(getWatchUrl(videoId), '_blank')}
                            className="text-red-400 hover:text-red-300 text-sm mt-2 flex items-center gap-1.5 transition-colors"
                        >
                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0C.488 3.45.029 5.804 0 12c.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0C23.512 20.55 23.971 18.196 24 12c-.029-6.185-.484-8.549-4.385-8.816zM9 16V8l8 4-8 4z" />
                            </svg>
                            Watch on YouTube
                        </button>
                    </div>
                )}
            </div>
        </Modal>
    );
}
